module.exports = __webpack_public_path__ + "img/jita-250.c4d5fa2e.jpg";